import { render } from "./InterestNoteList.vue?vue&type=template&id=04e69142"
import script from "./InterestNoteList.vue?vue&type=script&lang=js"
export * from "./InterestNoteList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patrykslak/Documents/lauron-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__